import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20vibrant%20anime%20style%20illustration%20with%20warm%20coral%20and%20amber%20color%20palette%2C%20featuring%20abstract%20manga%20panel%20layouts%2C%20speech%20bubbles%2C%20ink%20splashes%2C%20and%20dynamic%20motion%20lines%2C%20artistic%20comic%20book%20atmosphere%2C%20warm%20gradient%20background%20with%20soft%20glowing%20elements%2C%20immersive%20reading%20vibe&width=1600&height=900&seq=hero-bg-manga&orientation=landscape"
        alt="虫虫漫画 - 沉浸式韩国漫画阅读体验"
        title="虫虫漫画 - 二次元动漫世界"
        className="w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-900/50 via-foreground-900/30 to-foreground-900/60"></div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full max-w-3xl mx-auto px-4 text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 leading-tight">
            沉浸式<span className="text-primary-400">韩国漫画</span>体验
          </h1>
          <p className="text-base md:text-lg text-background-200/90 mb-8 max-w-xl mx-auto leading-relaxed">
            虫虫漫画打造二次元动漫世界，专注为您带来最优质的韩国漫画阅读体验。
            正版授权、高清画质、专业翻译，让每一页都成为视觉盛宴。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/all"
              className="inline-flex items-center px-8 py-3 text-sm font-medium rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
            >
              <i className="ri-book-open-line mr-2 w-4 h-4 flex items-center justify-center"></i>
              开始探索漫画
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center px-8 py-3 text-sm font-medium rounded-full bg-background-50/15 text-background-50 hover:bg-background-50/25 backdrop-blur-sm transition-all duration-300 whitespace-nowrap cursor-pointer border border-background-50/20"
            >
              了解更多
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 mt-12">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">1000+</p>
              <p className="text-xs text-background-300 mt-1">正版漫画</p>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">500万+</p>
              <p className="text-xs text-background-300 mt-1">忠实读者</p>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">99.7%</p>
              <p className="text-xs text-background-300 mt-1">好评率</p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/60 text-2xl w-6 h-6 flex items-center justify-center"></i>
      </div>
    </section>
  );
}